export const REF_NAME = 'VESSELBROKER';
export const REF_PATH = 'vesselbroker';
export const NAME = 'Ship broker';
